"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const WildlifeAvatar = () => /*#__PURE__*/_react.default.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 810 585"
}, /*#__PURE__*/_react.default.createElement("g", {
  fill: "none"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "#000",
  d: "M589.71.13l219.66 301.93-189.31 281.76H247.43l136.39-249.56h-96.19L.72.13z"
}), /*#__PURE__*/_react.default.createElement("path", {
  fill: "#FFF",
  d: "M155.08 66.52h134.75l67.7 91.04-23.99-91.04H438.6l67.92 90.38-22.9-90.38h83.15l37.8 193.8H483.29l-62.55-75.15 15.23 75.15H322.69zm450.53 444.45H384.1l103.2-193.8h119.52l-76.14 142.86h101.99z"
})));

var _default = WildlifeAvatar;
exports.default = _default;